export function windowScroll() {
  window.scrollTo({ top: 0 });
}

export function persistSessionState(storageKey: string, formState: any) {
  sessionStorage.setItem(storageKey, JSON.stringify(formState));
}
